import { getDashboardapi, changePasswordApi } from "../components/constant/Api";
import { myApi } from "./api";

export const dashboardApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: () => ({
        url: getDashboardapi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data[0] ?? "" : "";
      },
    }),
    changePassword: builder.mutation({
      query: (post) => ({
        url: changePasswordApi,
        method: "POST",
        body: post,
      }),
    }),

  }),
});

export const { useGetDashboardQuery, useChangePasswordMutation } = dashboardApi;